var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.54443,9.46973a.74972.74972,0,0,0-1.06054,0l-30,30A.74993.74993,0,0,0,10.01416,40.75H17.25V68a.7502.7502,0,0,0,.75.75H34.01416a.7502.7502,0,0,0,.75-.75V52.75h10.5V68a.7502.7502,0,0,0,.75.75H62a.7502.7502,0,0,0,.75-.75V40.75h7.26416a.74993.74993,0,0,0,.53027-1.28027ZM62,39.25a.7502.7502,0,0,0-.75.75V67.25H46.76416V52a.7502.7502,0,0,0-.75-.75h-12a.7502.7502,0,0,0-.75.75V67.25H18.75V40a.7502.7502,0,0,0-.75-.75H11.82471L40.01416,11.06055,68.20361,39.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.c8454314dea89b236a3b27f1f07fd34a.svg";
export { ForwardRef as ReactComponent };